var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6122 2.62137L5.15882 2.62134C3.25293 2.62134 1.87793 4.16161 1.87793 6.14443V9.92192C1.87793 11.9047 3.25293 13.445 5.15882 13.445H10.6071C11.5226 13.4348 12.389 13.0494 13.0098 12.3786C13.6306 11.7078 13.9515 10.8102 13.8978 9.89481L13.8986 6.14443C13.9515 5.25613 13.6306 4.35851 13.0098 3.68774C12.389 3.01696 11.5226 2.63159 10.6122 2.62137ZM5.15888 3.5404L10.6021 3.54037C11.2629 3.54779 11.8918 3.82752 12.3424 4.31441C12.793 4.8013 13.026 5.45285 12.987 6.11731L12.9862 9.92192C13.026 10.6135 12.793 11.265 12.3424 11.7519C11.8918 12.2388 11.2629 12.5185 10.6021 12.526L5.15888 12.5259C3.77983 12.5259 2.79045 11.4176 2.79045 9.92192V6.14442C2.79045 4.6487 3.77983 3.5404 5.15888 3.5404ZM11.5135 6.01177C11.356 5.81363 11.0689 5.78158 10.8722 5.94017L8.40726 7.92749L8.33661 7.97714C8.04597 8.15918 7.66433 8.14236 7.38594 7.92381L4.90296 5.93898L4.84707 5.90067C4.65449 5.78863 4.40438 5.83255 4.26198 6.01327C4.10535 6.21207 4.13837 6.50112 4.33574 6.65889L6.82186 8.6462L6.91885 8.71719C7.54425 9.14313 8.37302 9.11959 8.97282 8.64869L11.4424 6.65769L11.492 6.61137C11.6434 6.44727 11.6566 6.1919 11.5135 6.01177Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c8b0d716920bf507f572b76cc153d0cb.svg";
export { ForwardRef as ReactComponent };